import React from 'react';
import { Icon } from '@iconify/react';
import UserAvatar from './UserAvatar';
import NotificationBell from './NotificationBell';
import StatusCircle from './StatusCircle';
import { useTheme } from '../contexts/ThemeContext';
import { useUser } from '../contexts/UserContext';

const ThemeToggle = () => {
  const { isLightMode, toggleTheme } = useTheme();
  return (
    <button
      onClick={toggleTheme}
      aria-label={isLightMode ? 'Switch to dark mode' : 'Switch to light mode'}
      style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        width: 28, height: 28, borderRadius: 999, border: 'none',
        background: isLightMode ? 'none' : 'none',
        cursor: 'pointer', padding: 0, marginLeft: 6, flexShrink: 0,
      }}
    >
      <Icon
        icon={isLightMode ? 'solar:moon-bold' : 'solar:sun-bold'}
        width={14} height={14}
        style={{ color: isLightMode ? '#191919' : '#FBBF24' }}
      />
    </button>
  );
};

// Fake mod for testing push functionality
const PageHeader = ({ title, subtitle, user, rightElement, userId, onNotificationClick, textColor, borderless }) => {
  const { isAdmin } = useUser();

  return (
    <div className={`w-full h-11 flex items-center justify-between px-2 relative${borderless ? '' : ' border-b'}`} style={borderless ? undefined : { borderColor: 'var(--c-border)' }}>
      <div className="flex items-center gap-2 z-10">
        <UserAvatar user={user} />
        <StatusCircle />
        <ThemeToggle />
        {isAdmin && (
          <button
            onClick={() => window.dispatchEvent(new Event('notifications-simulate-trial'))}
            aria-label="Simulate trial expiration"
            className="flex items-center justify-center"
            style={{ width: 28, height: 28, borderRadius: 999, border: 'none', background: 'none', cursor: 'pointer', padding: 0, flexShrink: 0 }}
          >
            <Icon icon="solar:hourglass-bold" width={16} height={16} style={{ color: '#F59E0B' }} />
          </button>
        )}
      </div>
      
      {/* Center title — absolute so it's always perfectly centered */}
      {title && (
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <h1 className={`font-bold font-manrope uppercase tracking-[0.18em]`} style={{ fontSize: '10px', color: textColor || 'var(--c-texPri)' }}>
            {title}
          </h1>
        </div>
      )}
      
      <div className="flex items-center gap-3 z-10">
        {isAdmin && (
          <button
            onClick={() => window.dispatchEvent(new Event('notifications-simulate-sub'))}
            aria-label="Simulate subscription active"
            className="flex items-center justify-center"
            style={{ width: 28, height: 28, borderRadius: 999, border: 'none', background: 'none', cursor: 'pointer', padding: 0 }}
          >
            <Icon icon="solar:verified-check-bold" width={16} height={16} style={{ color: '#22C55E' }} />
          </button>
        )}
        {rightElement}
        {userId && (
          <NotificationBell 
            userId={userId} 
            onNotificationClick={onNotificationClick}
          />
        )}
      </div>
    </div>
  );
};

export default PageHeader;